import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";
import { range } from "@up/ui";

export function CollegeGraduationYear({
  label = "Graduation Year",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  const KEY = "college-graduation-year";
  const VALIDATION = { presence: true };
  const CURRENT_YEAR = new Date().getFullYear();
  const OPTIONS = range(CURRENT_YEAR + 7, CURRENT_YEAR - 72, -1);
  const LABEL = label;

  return (
    <RenderElement
      control={control}
      element={{
        _id: "college-graduation-year",
        type: "select",
        label: LABEL,
        name: KEY,
        options: OPTIONS,
        validate: VALIDATION,
        meta: {
          type: "year",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
